import React from "react";
import { useLazyLoadQuery } from "react-relay";
import { frequentlyAskedQuestionScreen_Query } from "@generated/frequentlyAskedQuestionScreen_Query.graphql";
import { QUERY } from "./frequently-asked-question-screen.graphql";
import { FrequentlyAskedQuestionAccordion } from "./parts/frequently-asked-question-accordion/frequently-asked-question-accordion.component";
import { usePageTitle } from "../../../infecto-lms-webapp/hooks/usePageTitle";
import { PageMainText } from "../../components/PageTitleText";
import { PageDefaultContainer } from "../../containers/PageDefaultContainer";
import { WideContainerWithTopBar } from "../../containers/WideContainerWithTopBar.container";

export const FrequentlyAskedQuestionScreen = () => {
	usePageTitle("FAQ");
	const query = useLazyLoadQuery<frequentlyAskedQuestionScreen_Query>(
		QUERY,
		{},
		{ fetchPolicy: "network-only" },
	);

	return (
		<PageDefaultContainer collapsed={false} screenName="FAQ">
			<WideContainerWithTopBar>
				<div className="mb-4">
					<PageMainText>FAQ - Wir haben ein paar Antworten für Sie zusammengestellt!</PageMainText>
				</div>
				<FrequentlyAskedQuestionAccordion
					items={query.FrequentlyAskedQuestion.AllFrequentlyAskedQuestions}
				></FrequentlyAskedQuestionAccordion>
			</WideContainerWithTopBar>
		</PageDefaultContainer>
	);
};
